import React, { useState } from 'react';
import PropTypes from 'prop-types'
import jwt from 'jsonwebtoken';
import '../../Auth/AuthPage.scss'
import AuthFormV2 from '../../Common/AuthCommon/AuthFormV2';
import AuthFormSeparator from '../../Common/AuthCommon/AuthFormSeparator';
import GoogleAuth from '../../Common/AuthCommon/GoogleAuth';
import { AUTH_TO_SHOW } from './AuthComponent';
import { MessageConstant, ButtonConstant } from '../../../constants';
import { ErrorNotification } from '../../Common/AuthCommon/ErrorNotification';

const AuthPageForm = ({ onSwitchForm, type, title, errorMessage, loading, onSubmit, onSubmitWithSocialAccount, resetError, onAuthSuccessCallback }) => {
    const [socialError, setSocialError] = useState('');
    const handleSubmit = (values) => {
        onSubmit(values, onAuthSuccessCallback);
        setSocialError('');
    };

    const responseGoogle = (response) => {
        if (response) {
          const token = response.credential || '';
          const decoded = jwt.decode(token);
    
          const googleData = {
            type: ButtonConstant.GOOGLE_SIGNIN,
            googleId: decoded.sub || '',
            email: decoded.email || '',
            firstName: decoded.given_name || '',
            lastName: decoded.family_name || '',
            accessToken: token,
          };
    
          localStorage.setItem('userFullName', `${googleData.firstName} ${googleData.lastName}`);
          onSubmitWithSocialAccount(googleData, onAuthSuccessCallback);
        } else {
          log4Social(0, 1, JSON.stringify(response), 0);
          setSocialError('Sorry, sign in with Google failed.');
        }
    };

    const log4Social = (socialType, actionType, response, status) => {
        const params = {
          socialType,
          actionType,
          response,
          status,
        };
    
        service.log4Social(params);
    };
    
    const renderError = () => {
    if (errorMessage) {
        if (errorMessage === MessageConstant.ACCOUNT_NOT_EXISTS) {
        return {
            emailError: <span className="error-text">{errorMessage}</span>,
        };
        } else if (errorMessage === MessageConstant.INVALID_PASSWORD) {
        return {
            passwordError: <span className="error-text">{errorMessage}</span>,
        };
        }
        return {
        errorMessage: <ErrorNotification message={errorMessage} />,
        };
    }

    if (socialError) {
        return {
        socialError: <ErrorNotification message={socialError} />,
        };
    }
    return {};
    };

    const { emailError, passwordError, errorMessage: generalErrorMessage, socialError: generalSocialError } = renderError();

    return (
        <>
            <div className="auth-page__title">
                <h4>{title}</h4>
                <p className={`auth-page__paragraph ${type}`}>
                {type === 'signIn' ? (
                    <>
                    Don't have an account? <span className="auth-page__link" onClick={() => onSwitchForm(AUTH_TO_SHOW.SIGNUP)}>Sign up here</span>
                    </>
                ) : (
                    <>
                    Already have an account? <span className="auth-page__link" onClick={() => onSwitchForm(AUTH_TO_SHOW.LOGIN)}>Log in here</span>
                    </>
                )}
                </p>
            </div>
            <AuthFormV2 type={type} form={type + 'Form'} onSubmit={handleSubmit} loading={loading} emailError={emailError} passwordError={passwordError} resetError={resetError} />
            {generalSocialError || generalErrorMessage}
            <AuthFormSeparator />
            <GoogleAuth responseGoogle={responseGoogle} type={type} />
        </>
    )
}

AuthPageForm.propTypes = {
    onSwitchForm: PropTypes.func.isRequired,
    onAuthSuccessCallback: PropTypes.func,
    type: PropTypes.string,
    title: PropTypes.string,
    errorMessage: PropTypes.string,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func,
    onSubmitWithSocialAccount: PropTypes.func,
    resetError: PropTypes.func,
}

export default AuthPageForm;